<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:05:14
 * @Description: 维保项明细
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="维保项明细"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="180px"
        label-suffix="："
      >
        <!-- 基本信息 -->
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="设备位置"
              prop="sbwz"
            >
              <span
                class="c-form__read"
              >
                {{ fd.sbwz }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="电源外箱是否完好?"
              prop="status"
            >
              <el-radio-group v-model="fd.status">
                <el-radio label="Y">
                  是
                </el-radio>
                <el-radio label="N">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="备注信息"
              prop="wzxx"
            >
              <span
                class="c-form__read"
              >
                {{ fd.wzxx }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <template>
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            附件列表
          </el-col>
          <!-- <el-table
            ref="listTable"
            class="c-page__table o-header-text-center"
            stripe
            border
            highlight-current-row
            tooltip-effect="dark"
            :data="tableData.rows"
            :class="{ 'o-table-empty-center': tableData.rows.length <= 0 }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="40"
              align="center"
            />
            <el-table-column
              prop="name"
              label="合同附件"
              min-width="180"
            >
              <template slot-scope="scope">
                <span
                  class="c-form__read"
                >
                  {{ scope.row.fileName || '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.yxqq | date("yyyy-MM-dd ") }}  至 {{ scope.row.yxqz | date("yyyy-MM-dd ") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="htje"
              label="合同金额（元）"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.htje }}
              </template>
            </el-table-column>
          </el-table> -->
        </template>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WbxmxDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      tableData: {
        rows: []
      },
      /* 表单参数 Start */

      // actionUrl: `${ctxPrefix}${iffApi}/wbht/upload`,
      /* 表单参数 Start */
      fd: {
        id: null,
        khmc: null, // 客户名称
        htmc: null // 合同名称
      }
      /* 表单校验规则 End */

    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }

  },
  created () {
    // this.$nextTick(() => {
    // this.fd.id = this.dlParams.id;
    // this.initial();
    // });
    //
  }
};

</script>
